/**
 * Hooks that run after cognito login
 */

import { useAuth } from "@/utils/Auth/useAuth"
import { useGetUserHiringresource } from "../../openapi/api/endpoints/default/default"
import { getPermissionsHeader, useGetPermissionsHeader } from "./useGetPermissionIdUnAuth"
import { AuthState } from "@/store/authentication"
import { queryClient } from "@/App"
/**
 * 1-Gets Hr
 * 2-Gets permissions header
 * 3-Sets things in cache
 */
const useOnAuth = ({onAuthSuccess}:{onAuthSuccess?:()=>void}) => {
    const {setSessionData}=useAuth()
    const {data, refetch:getHrUser}=useGetUserHiringresource({
        query:{
            enabled:false,
            staleTime: 5 * 60 * 1000, // Example: 5 minutes
        }
    })
    const {isSuccess:permissionSuccess,isLoading:permissionLoading}=useGetPermissionsHeader({licenseId:data?.licenseId??''})
    

    const triggerAuthRoutine=async ({sessionData}:{sessionData: AuthState})=>{
        try{
            const {data:hrUser}=await getHrUser({throwOnError:true})
            console.log({hrUser})
            if(!hrUser){
                console.log('no user found')
                return
            }
            console.log({sessionData})
            if(!sessionData?.token){
                console.log('NO TOKEN')
                return
            }
            const {data:permission}=await queryClient.ensureQueryData({
                queryKey:['/permissionsHeaderCustom/'],
                queryFn:()=> getPermissionsHeader({licenseId:hrUser.licenseId, token:sessionData?.token as string})})
            console.log({permission})
            setSessionData({...sessionData as AuthState, permission})
            setTimeout(()=>{},3000) //letting cache stabilize
            onAuthSuccess&&onAuthSuccess()
            console.log('Auth routine successful')
        }catch(e){
            console.log('AuthRoutineError',e)
            throw e
        }

    }


    return {
        permissionLoading,permissionSuccess,hrRefetch:triggerAuthRoutine
    }
}

export default useOnAuth